<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'RenderSubMenu',
})
</script>
<template>
  <!-- 渲染有子菜单的菜单项 -->
  <a-sub-menu 
    v-if="menu.children && !menu.hideChildrenInMenu" 
    :key="menu.path" 
    popupClassName="popupSubMenu"
  >
    <template #icon>
      <!-- 使用自定义Icon组件渲染子菜单图标 -->
      <Icon 
        v-if="menu.meta?.icon" 
        :name="menu.meta.icon" 
        :size="16" 
        color="#fff"
      />
    </template>
    <template #title>{{ $t(menu.meta.title) }}</template>
    <template v-if="!menu.hideChildrenInMenu">
      <template v-for="sub in menu.children" :key="sub.path">
        <!-- 递归渲染子菜单 -->
        <RenderSubMenu :menu="sub" />
      </template>
    </template>
  </a-sub-menu>

  <!-- 渲染无子菜单的菜单项 -->
  <a-menu-item 
    :key="menu.path" 
    v-else-if="!menu.meta?.hidden"
  >
    <template #icon>
      <!-- 统一使用自定义Icon组件，移除SvgIcon依赖 -->
      <Icon 
        v-if="menu.meta?.icon" 
        :name="menu.meta.icon" 
        :size="16" 
        color="#fff"
      />
    </template>

    <!-- 外部链接处理 -->
    <a 
      v-if="menu.meta?.target" 
      :href="menu.meta.target" 
      :target="menu.meta.blank === false ? '' : '_blank'"
      rel="noopener noreferrer"
    >
      <span>{{ $t(menu.meta.title) }}</span>
    </a>

    <!-- 内部路由链接处理 -->
    <router-link 
      v-else 
      :to="filterParams(menu.path)"
    >
      <span>{{ $t(menu.meta.title) }}</span>
    </router-link>
  </a-menu-item>
</template>

<script lang="ts" setup name="RenderSubMenu">
import { defineProps, type PropType } from 'vue'
import { type Router } from '@/router/types' // 导入路由类型定义
import Icon from '@/components/Common/Icon' // 导入自定义Icon组件

// 严格定义props类型，避免隐式any
const props = defineProps({
  menu: {
    type: Object as PropType<Router>,
    required: true,
    validator: (val: Router) => {
      return !!val.path && !!val.meta?.title
    }
  }
})

// 处理有子菜单但需要隐藏子菜单的场景
if (props.menu.children && props.menu.hideChildrenInMenu) {
  props.menu.children.forEach((item) => {
    item.meta = Object.assign({}, item.meta, { hidden: true })
  })
}

// 过滤路由路径中的参数（如 /list/:pageNo → /list）
const filterParams = (path: string): string => {
  if (typeof path !== 'string') return ''
  return path.indexOf('/:') > 0 ? path.split('/:')[0] : path
}
</script>

<style lang="less" scoped>
// 图标和文字垂直对齐优化
:deep(.ant-menu-item-icon),
:deep(.ant-menu-submenu-icon) {
  display: flex;
  align-items: center;
  justify-content: center;
  
  .custom-icon {
    width: 16px !important;
    height: 16px !important;
    color: #fff;
  }
}

// 菜单文字样式优化
:deep(.ant-menu-title-content) {
  span {
    vertical-align: middle;
  }
}

// 移除冗余样式，保留核心对齐规则
.menuName {
  svg,
  span {
    vertical-align: middle;
  }

  svg {
    margin-right: 10px;
  }
}
</style>